<template lang="html">
<div class="row" style="padding: 15px 35px;">
  <div v-if="messages.length > 0" class="message-tabs">
    <h4>{{ $t("notifications.notifications") }}</h4>
    <div
      v-for="mGroup in message_groups"
      :key="mGroup.key"
      :title="mGroup.title"
      @click="showMessages(mGroup)"
    >
      <div :class="mGroup.status_class"></div>
      <div>{{ groupMessages(mGroup.key).length }}</div>
    </div>
  </div>

  <Modal :show="messages_modal" @hide="messages_modal = false">
    <div slot="body">
      <div class="message-tabs">
        <div v-for="status in messageGroupStatuses(selectedGroupMessages)">
          <div :class="['status', status]"></div> {{ MESSAGE_STATUSES[status] }}
        </div>
        <div v-for="failure in messageGroupFailures(selectedGroupMessages)">
          <div :class="failureStatusClass(failure)"></div>
          <div v-if="failure in FAILURE_STATUSES">
            {{ FAILURE_STATUSES[failure].title }}
          </div>
          <div v-else>{{ failure }}</div>
        </div>
      </div>
      <MessageGroupList
        :messages="selectedGroupMessages"
        :failure_statuses="FAILURE_STATUSES"
      />
    </div>
  </Modal>

  <div>
  </div>
</div>
</template>

<script>
// Marker messages component
// Render the push notification delivery status for a marker

import MessageRepository from '../../repositories/MessageRepository.js'
import events from '../../services/events'
import Dates from '../../services/dates'
import MessageGroupList from './MessageGroupList'
import Modal from '@/components/generic/Modal'

export default {
  components: {
    MessageGroupList,
    Modal
  },
  props: [
    'markerId'
  ],

  data: function () {
    return {
      messages: [],
      timer: '',
      loading: true,
      DELIVERY_STATUS_NOTSENT: [
        'disabled_device',
        'inactive_device',
        'error'
      ],
      DELIVERY_STATUS_FAILURE: [
        'failure'
      ],
      DELIVERY_STATUS_SUCCESS: [
        'opened',
        'delivered',
        'in_app'
      ],
      MESSAGE_STATUSES: {
        'opened': 'Opened',
        'delivered': 'Delivered',
        'in_app': 'In app',
        'disabled_device': 'Device disabled',
        'inactive_device': 'Device inactive',
        'error': 'Some error',
        'failure': 'Delivery failed',
        'processing': 'Processing'
      },
      FAILURE_STATUSES: {
        'Can not create endpoint': {
          status_class: 'status cnc_endpoint',
          title: 'Can not create endpoint',
        },
        'InvalidPlatformToken': {
          status_class: 'status invalid_plt',
          title: 'Invalid platform token',
        },
      },
      message_groups: [
        {
          key: 'delivered',
          title: 'Delivered messages',
          status_class: 'status success',
        }, {
          key: 'not_sent',
          title: 'Not sent messages because of device inactive or disabled or some error happend',
          status_class: 'status notsent',
        }, {
          key: 'failed',
          title: 'Messages have been sent but delivery failed',
          status_class: 'status failure',
        }, {
          key: 'pending',
          title: 'Processing messages',
          status_class: 'status pending',
        }, {
          key: 'disabled',
          title: 'User diable notification permission',
          status_class: 'status disabled',
        }
      ],
      selected_message_group: {},
      messages_modal: false
    }
  },

  mounted: function () {
    if (this.markerId) {
      this.setup(this.markerId)
    }
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },

  methods: {
    setup (markerId) {
      this.setupInterval(markerId)
      this.fetchMessages(markerId)
    },
    setupInterval (markerId) {
      clearInterval(this.timer)
      this.timer = setInterval(this.updateMessages.bind(this, markerId), 20000)
    },
    readableDate (timestamp) {
      return Dates.longFormat(Dates.parseDate(timestamp))
    },
    updateMessages (markerId) {
      MessageRepository.fetchMarkerMessages(markerId).then((messages) => {
        this.messages = messages
      })
    },
    fetchMessages (markerId) {
      this.loading = true
      MessageRepository.fetchMarkerMessages(markerId).then((messages) => {
        this.loading = false
        this.messages = messages
      }, (error) => {
        this.loading = false
        events.emit('error', error)
      })
    },
    groupMessages (key) {
      const map = {
        delivered: this.deliveredMessages,
        failed: this.failedMessages,
        not_sent: this.notSentMessages,
        pending: this.pendingMessages,
        disabled: this.disabledMessages
      }
      return map[key]
    },
    showMessages (group) {
      this.selected_message_group = group
      this.messages_modal = true
    },
    hideMessages () {
      this.messages_modal = false
    },
    messageGroupStatuses (messages) {
      // get list of unique statuses that present in messages list
      return [...new Set(messages.map(mes => mes.delivery_status))]
    },
    messageGroupFailures (messages) {
      let failures = []
      messages.forEach(mes => {
        if (mes.failures.length) failures = failures.concat(mes.failures)
      })
      return [...new Set(failures.map(failure => failure.failure_type))]
    },
    failureStatusClass (failure) {
      if (failure in this.FAILURE_STATUSES) {
        return this.FAILURE_STATUSES[failure].status_class
      }
      return 'status unmapped'
    }
  }, // methods

  computed: {
    sortedMessages () {
      return this.messages.slice().sort(sortIdAsc)
    },
    deliveredMessages () {
      return this.sortedMessages.filter(
        mes => this.DELIVERY_STATUS_SUCCESS.indexOf(mes.delivery_status) !== -1
      )
    },
    failedMessages () {
      return this.sortedMessages.filter(mes => {
        return this.DELIVERY_STATUS_FAILURE.indexOf(mes.delivery_status) !== -1 &&
          mes.notification_permission !== false
      })
    },
    notSentMessages () {
      return this.sortedMessages.filter(mes => {
        return this.DELIVERY_STATUS_NOTSENT.indexOf(mes.delivery_status) !== -1 &&
          mes.notification_disabled !== false
      })
    },
    pendingMessages () {
      return this.sortedMessages.filter(
        mes => mes.delivery_status === 'processing'
      )
    },
    disabledMessages () {
      return this.sortedMessages.filter(
        mes => mes.notification_permission === false
      )
    },
    selectedGroupMessages () {
      if (this.selected_message_group.key) {
        return this.groupMessages(this.selected_message_group.key)
      }
      return []
    }
  }
}

function sortIdAsc (a, b) {
  return a.id - b.id
}
</script>



// WEBPACK FOOTER //
// MarkerMessages.vue?4b91626c